import React from 'react';
import { Trash } from '@saleshandy/icons';

import Modal from '../../../shared/design-system/ui/modal';

interface DeleteModalProps {
  show: boolean;
  onSubmit: () => void;
  onClose: () => void;
  isLoading: boolean;
}

const DeleteModal: React.FC<DeleteModalProps> = ({
  show,
  onSubmit,
  onClose,
  isLoading,
}) => (
  <Modal
    show={show}
    className="delete-domain-confirmation-modal"
    title={
      <div className="d-flex align-items-center gap-8">
        <Trash width={24} height={24} color="#1F2937" />
        <span className="line-height-1">
          Are you sure you want to delete this Inframail IP?
        </span>
      </div>
    }
    onHide={onClose}
    primaryBtnLabel="Delete"
    secondaryBtnLabel="Cancel"
    primaryBtnClickedHandler={onSubmit}
    secondaryBtnClickedHandler={onClose}
    primaryBtnDisabled={isLoading}
    primaryBtnLoading={isLoading}
  >
    <>
      <div className="section-one">
        <p>
          By deleting this IP, you will stop any ongoing charges for it. All
          domains and mailboxes linked to this IP will be permanently removed
          from your account.
        </p>
        <p>
          <b>Important:</b> Deleting this IP will immediately halt any active
          sequences or warmup activities associated with it. As a result, emails
          will no longer be sent from this IP.
        </p>
      </div>
      <div className="section-two">
        <p>
          Please note: Once you delete the IP, this action cannot be undone.
          Additionally, any unused days for the IP will not be refunded.
        </p>
      </div>
    </>
  </Modal>
);

export default DeleteModal;
